
  import {defineComponent,PropType,computed} from "vue"
  import {Message} from "@/models/message.interface";
  import {Device} from "@/models/devices.interface";
  import {DeviceService} from "@/services/device.services";
  import {UserService} from "@/services/user.service";
  import {SMSMessage} from "@/models/message.interface";

  export default defineComponent({
   name: "MessageComponent",
   emits:["deviceModified"],
   props:{
      device:{
	type: Object as PropType<SMSMessage> 
      }      
    },
    setup(props,context){

      const serviceDevice = new DeviceService();
      const serviceUser = new UserService();

      const imgStatus= (status)=>{
	 let img="../img/water-tap.png"; 
	switch(status){
	  case "unattended":
	    img=require("@/img/water-tap.png");
	    break;
	  case "asigned":
	    img = require("@/img/dia.png");
	    break;
	  case "closed":
	    img = require("@/img/tap.png");
	    break;
	 }
	return img;
      };

    const label_asigned = (user)=>{
      return "hola";
    }

      const asignSMS = async (phone_number,phone_id)=>{
	const exito =await serviceDevice.change_estatus_message(serviceUser.fetch().token, phone_number,phone_id,"asigned");
	if(exito){
	context.emit("deviceModified",{phone_number,phone_id});
	}
      }


      const closeSMS = async (phone_number,phone_id)=>{
	await serviceDevice.change_estatus_message(serviceUser.fetch().token, phone_number,phone_id,"closed");
	
	context.emit("deviceModified",{phone_number,phone_id});
      }

      return {imgStatus,label_asigned,closeSMS,asignSMS};
    }//setup
  });
